import React, { useContext } from "react";
export const AffiliateContext = React.createContext(null);
export const useAffiliateContext = () => useContext(AffiliateContext);
